import React from "react";
import { AwardCard } from "~/molecules/AwardCard";

type Props = {
  awards: GatsbyTypes.ContentfulAwardConnection;
};

export const AwardCards: React.FC<Props> = ({ awards }) => {
  return (
    <>
      <style jsx>{`
        .articles {
          display: flex;
          flex-wrap: wrap;
          position: relative;
          width: 100%;
        }
      `}</style>
      <ul className="articles">
        {awards.edges.map((edge) => (
          <AwardCard key={`Awards_${edge.node.contentful_id}`} article={edge.node} />
        ))}
      </ul>
    </>
  );
};
